'use client';

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { AuthLayout } from '@/features/authentication/presentation/components/AuthLayout';
import { Button } from '@/core/presentation/components/ui/Button';
import { VerifySubscriptionView } from '@/features/payments/presentation/components/VerifySubscriptionView';
import { useVerifySubscriptionBridge } from '@/features/payments/presentation/composables/bridges/VerifySubscriptionBridge';
import { VERIFY_SUBSCRIPTION_STRIPE_HINT } from '@/features/payments/presentation/constants/verify-subscription-copy';
import { SubscriptionFlowStepper } from '@/features/plans/presentation/components/SubscriptionFlowStepper';

/**
 * Confirmação pós-checkout — escuta `payments/{payment_id}` e redireciona ou oferece retorno aos planos.
 */
export const VerifySubscriptionScreen: React.FC = () => {
  const { layout, view, footer } = useVerifySubscriptionBridge();

  const showHint =
    !view.authBlocking &&
    (view.phase === 'listening' || view.phase === 'unauthenticated');

  return (
    <AuthLayout
      title={layout.title}
      maxWidthClassName="max-w-lg"
      footer={
        footer.visible ?
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={footer.onBackToPlans}
            className="font-medium text-cyan hover:text-cyan-light hover:underline hover:underline-offset-2 hover:bg-transparent focus-visible:underline focus-visible:underline-offset-2 focus-visible:ring-2 focus-visible:ring-cyan"
          >
            <span className="relative inline-block">
              <ArrowLeft
                className="pointer-events-none absolute right-full top-1/2 mr-4 size-4 shrink-0 -translate-y-1/2"
                aria-hidden
              />
              {footer.label}
            </span>
          </Button>
        : undefined
      }
    >
      <div className="space-y-6">
        <SubscriptionFlowStepper activeStep={4} />
        <VerifySubscriptionView {...view} />
        {showHint ?
          <p className="text-center text-xs text-white/60 leading-relaxed px-1">
            {VERIFY_SUBSCRIPTION_STRIPE_HINT}
          </p>
        : null}
      </div>
    </AuthLayout>
  );
};
